import { render, staticRenderFns } from "./AddStudent.vue?vue&type=template&id=4cbadd3d"
import script from "./AddStudent.vue?vue&type=script&lang=js"
export * from "./AddStudent.vue?vue&type=script&lang=js"
import style0 from "./AddStudent.vue?vue&type=style&index=0&id=4cbadd3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports